<template>
    <div>
        <public-title>酒店房态</public-title>
        <div class="bg-white box-shadow p-3">
            <el-row class="smheight pt-3">
                <el-col :span="12">
                    <left-text-border class="mb-3 w-80" leftText="酒店名称" v-model="title"/>
                    <select-city class="mb-3 w-80"
                    leftText="区域"
                    mutiBlocks
                    @getCityInfo="info => this.cityInfo = info"
                    :provinceId="cityInfo.province"
                    :cityId="cityInfo.city"
                    :districtIds="cityInfo.district.map(v => v.id)"/>
                </el-col>
                <el-col :span="12">
                    <div class="w-80 mb-3 d-flex fRight align-items-center">
                        <left-text leftText="提交时间"/>
                        <el-date-picker class="w-100" size="small" v-model="timestamp" type="daterange" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
                    </div>
                    <left-text-select class="w-80 fRight" leftText="星级" :options="$GVAR.HotelStar.slice(1,10)" v-model="storeStar" />
                </el-col>
            </el-row>
            <div class="text-right text-link" @click="page=1;getPush()">搜索</div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="酒店名称">
                    <template slot-scope="scope">
                        <el-popover placement="right" trigger="hover">
                            {{scope.row.store_title}}<span slot="reference">{{scope.row.store_title | formatString(10)}}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">{{scope.row.roomstate_type == '1' ? '表格模式' : '文字模式'}}</template>
                </el-table-column>
                <el-table-column label="区域">
                    <template slot-scope="scope">
                        {{scope.row.proName}}/{{scope.row.cityName}}/{{scope.row.disName}}
                    </template>
                </el-table-column>
                <el-table-column label="星级">
                    <template slot-scope="scope">{{scope.row.star | formatVar('HotelStar')}}</template>
                </el-table-column>
                <el-table-column label="提交时间">
                    <template slot-scope="scope">{{scope.row.time | formatTimestamp(1)}}</template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <div :class="{'text-danger': scope.row.status == 0}">
                            <div v-if="scope.row.status == 0" class="text-danger">未推送</div>
                            <div v-if="scope.row.status == 1" class="text-blue">已推送</div>
                            <div v-if="scope.row.status == 2">已取消</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="text-link" @click="goDetail(userLoginMessage.store_ids[0], scope.row.store_type, scope.row.id)">查看</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                        v-if="tableData.length > 0" :page-size="10"
                         :total="total" @current-change="v => {page=v;getPush()}"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'TourRType',
    data () {
        return {
            tableData: [],
            title: '',
            timestamp: [],
            cityInfo:{
                province: '',
                city: '',
                district: []
            },
            storeStar: '',
            total: 0,
            page: 1,
            area: false
        }
    },
    computed: {
        //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : '' },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : '' },
      ...mapState(['userLoginMessage']),
    },
    created () { this.getPush() },
    methods: {
        async getPush () {
            let res = await this.$axios.post('pc/Travel/getRoomStatePushedList', {
                store_title: this.title, start_time: this.startTime, end_time: this.endTime,star: this.storeStar,
                pro: this.cityInfo.province, city: this.cityInfo.city, dis: this.cityInfo.district.map(v => v.id),
                page: this.page,num: 10
            })
            if (res.code === '00000' || res.code === '99999') { 
                this.tableData = res.data || [];
                this.total = res.count || 0
            }
        },
        // 跳转详情
        goDetail (store_id,type,room_state_id) {
            this.$router.push({name:'RoomDetail',query:{store_id,type,room_state_id}})
        }
    }
}
</script>

<style lang="scss" scoped>
.fRight{
    float: right;
}
.box-shadow{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) 
}
</style>
